import * as React from 'react'

export const EmailTick = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.1724 23.2695L68.1776 25.6471C69.3272 26.5642 69.9977 27.9541 70 29.4247V65.173C70 67.8392 67.8386 70.0006 65.1724 70.0006H4.82759C2.16138 70.0006 0 67.8392 0 65.173V29.4247C0.00229682 27.9541 0.672807 26.5642 1.82241 25.6471L4.82759 23.2695H65.1724Z"
      fill="#5B332E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.82764 57.6172V2.41379C4.83161 1.08234 5.90998 0.00397648 7.24143 0H62.7587C64.0901 0.00397648 65.1685 1.08234 65.1725 2.41379V56.3621L4.82764 57.6172Z"
      fill="#FFF0EF"
    />
    <path
      d="M35.0001 38.6212C44.3318 38.6212 51.8966 31.0564 51.8966 21.7247C51.8966 12.393 44.3318 4.82812 35.0001 4.82812C25.6684 4.82812 18.1035 12.393 18.1035 21.7247C18.1035 31.0564 25.6684 38.6212 35.0001 38.6212Z"
      fill="#AB837E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.3793 31.3794C30.7389 31.3806 30.1246 31.126 29.6728 30.6722L24.8452 25.8446C23.9304 24.8974 23.9435 23.392 24.8746 22.4609C25.8057 21.5298 27.3112 21.5167 28.2583 22.4315L31.3793 25.5513L41.7417 15.1901C42.3478 14.5626 43.2452 14.311 44.0892 14.5319C44.9331 14.7528 45.5922 15.4118 45.8131 16.2558C46.034 17.0997 45.7823 17.9971 45.1548 18.6032L33.0859 30.6722C32.6341 31.126 32.0197 31.3806 31.3793 31.3794Z"
      fill="#FFF7F6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.0001 30.0645L70.0001 65.1731C70.0058 66.5432 69.4209 67.8494 68.3949 68.7576L45.6328 51.0645L70.0001 30.0645Z"
      fill="#E1B9B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.3949 68.7568C67.5118 69.556 66.3635 69.9989 65.1725 69.9999H4.82764C3.63661 69.9989 2.48833 69.556 1.60522 68.7568L24.3673 51.0637L33.5035 43.9672C34.3826 43.2792 35.6175 43.2792 36.4966 43.9672L45.6328 51.0637L68.3949 68.7568Z"
      fill="#EDC5C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.3673 51.0645L1.60521 68.7576C0.579194 67.8494 -0.00573911 66.5432 4.24586e-05 65.1731L0 30.0645L24.3673 51.0645Z"
      fill="#E1B9B4"
    />
  </svg>
)
